import { useState, useEffect } from 'react';

const defaultCacheConfig = {
  staleTTL: 10,
  expiredTTL: 30
};
function usePersistedData(config) {
  const {
    cacheKey,
    fetchValue,
    id
  } = config;
  const storageKey = `${cacheKey}_${id ?? "default"}`;
  const isBrowser = typeof window !== "undefined";
  const [state, setState] = useState(() => {
    const storedValue = isBrowser ? localStorage.getItem(storageKey) : null;
    return storedValue ? JSON.parse(storedValue) : void 0;
  });
  const [valueToReturn, setValueToReturn] = useState(
    state?.value
  );
  const setRefreshedState = (key, value, cacheConfig, checkCurrent) => {
    if (checkCurrent() && isBrowser) {
      if (value) {
        const cacheValue = {
          key,
          value,
          staleTime: Date.now() + cacheConfig.staleTTL * 1e3,
          expireTime: Date.now() + cacheConfig.expiredTTL * 1e3
        };
        localStorage.setItem(storageKey, JSON.stringify(cacheValue));
        setState(cacheValue);
      }
    }
  };
  useEffect(() => {
    let isCurrent = true;
    const checkCurrent = () => isCurrent;
    if (isCacheStale(state) || isCacheExpired(state, cacheKey)) {
      fetchValue(
        (newValue, cacheConfig = defaultCacheConfig) => setRefreshedState(cacheKey, newValue, cacheConfig, checkCurrent)
      );
    }
    return () => {
      isCurrent = false;
    };
  }, [cacheKey]);
  useEffect(() => {
    const returnedStateValue = isCacheExpired(state, cacheKey) ? void 0 : state?.value;
    setValueToReturn(returnedStateValue);
  }, [state]);
  return [valueToReturn];
}
const isCacheStale = (cache) => {
  return !cache || Date.now() > cache.staleTime;
};
const isCacheExpired = (cache, stateKey) => {
  return !cache || Date.now() > cache.expireTime || cache.key !== stateKey;
};

export { defaultCacheConfig, usePersistedData };
//# sourceMappingURL=src-hooks-usePersistedData.js.map
